import { searchConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

//schedule interview
export const search_skill_user_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_SKILL_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_SKILL_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_SKILL_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

//schedule interview
export const search_job_user_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_JOB_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_JOB_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_JOB_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

//schedule interview
export const search_event_user_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_EVENT_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_EVENT_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_EVENT_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

//schedule interview
export const search_company_user_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_COMPANY_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_COMPANY_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_COMPANY_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

//schedule interview
export const search_assessment_kit_user_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_ASSESSMENT_KIT_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_ASSESSMENT_KIT_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_ASSESSMENT_KIT_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

export const search_country_user_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_COUNTRY_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_COUNTRY_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_COUNTRY_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

export const search_city_user_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_CITY_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_CITY_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_CITY_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

export const search_state_user_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_STATE_USER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_STATE_USER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_STATE_USER_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

export const search_candidate_kanban_board_user_action =
  (data) => async (dispatch) => {
    dispatch({
      type: searchConstants.SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        `${config.search.search}`,
        data
      );
      if (response.status) {
        dispatch({
          type: searchConstants.SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: searchConstants.SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_FAILURE,
        payload: e?.msg,
      });
      showWarningMessage(e?.msg);
    }
  };

export const search_company_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_COMPANY_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_COMPANY_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_COMPANY_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

export const search_job_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_JOBS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_JOBS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_JOBS_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

export const search_candidate_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_CANDIDATE_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_CANDIDATE_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_CANDIDATE_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

export const search_mentor_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.SEARCH_MENTOR_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.SEARCH_MENTOR_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.SEARCH_MENTOR_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

export const get_all_skills_action = (data) => async (dispatch) => {
  dispatch({
    type: searchConstants.GET_ALL_SKILLS_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.search.search}`, data);
    if (response.status) {
      dispatch({
        type: searchConstants.GET_ALL_SKILLS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: searchConstants.GET_ALL_SKILLS_ACTION_FAILURE,
      payload: e?.msg,
    });
    showWarningMessage(e?.msg);
  }
};

